export default [{
    text: 'НДС включен',
    value: 'included'
}, {
    text: 'НДС не включен',
    value: 'notIncluded'
}, {
    text: 'УСН (упрощенная система налогообложения)',
    value: 'usn'
}];
